import React, { useState } from 'react'
import Modal from '../../modal'
import CloseSVG from '../../../../assets/svg/close.svg'
import ArrowRight from '../../../../assets/svg/arrowRight.svg'

import { useSelector } from 'react-redux'
import { Initials } from '../../../../utils/functions'
import Button from '../../../button'
import {
  useAddQueryMessage,
  useGetQueryMessage,
} from '../../../../redux/human-resources/hook/queries'

const QueryModal = ({ isOpen, closeModal, query }) => {
  const { user } = useSelector((state) => state.userSlice)
  const { mutateAsync: addQueryMessage, isLoading: addQueryMessageloading } =
    useAddQueryMessage()

  const [inputValue, setInputValue] = useState('')
  const {
    refetch: refetchMessages,
    data: queryMessage,
    isLoading: messageLoading,
  } = useGetQueryMessage(query?.id)

  const submitForm = async () => {
    if (!inputValue.trim()) return

    let payload = {
      comment: inputValue,
      query_id: query?.id,
    }
    await addQueryMessage(payload).then(() => {
      refetchMessages()
      setInputValue('')
    })
  }

  return (
    <Modal
      scrollable={true}
      className='md:!w-[600px] !w-[95%]'
      isOpen={isOpen}
      centered={true}
    >
      <div className='flex flex-col p-3 w-full overflow-auto'>
        <div className='flex justify-between w-full items-center'>
          <div className='flex gap-3 items-center'>
            <div className='flex font-bold justify-center items-center h-[40px] w-[40px] rounded-[10px] header-4 border-2 border-secondary-2 bg-green-200'>
              {Initials(user?.first_name, user?.last_name)}
            </div>
            <div className='flex flex-col'>
              <p className='text-[18px] font-medium'>
                {user?.first_name + ' ' + user?.last_name}{' '}
              </p>
              <p className='text-sm text-hr-primary-1'>Online</p>
            </div>
          </div>
          <div className='cursor-pointer' onClick={() => closeModal()}>
            <img src={CloseSVG} alt='' />
          </div>
        </div>
        <hr className='w-full my-2 h-[2px] bg-[#96969B]' />

        <div className='flex flex-col gap-4 w-full max-h-[400px] overflow-y-auto py-2'>
          <main className='flex flex-col gap-4 w-[95%] mx-auto h-full py-2'>
            {queryMessage?.length === 0 ? (
              <div className='flex items-center justify-center font-bold text-base text-center my-10'>
                Send messages to {user?.first_name}{' '}
                {user?.last_name}{' '}
              </div>
            ) : (
              queryMessage?.map((msg) => (
                <div
                  key={msg.id}
                  className={`flex ${
                    msg.sender_name !== 'HR' ? 'justify-end' : 'justify-start'
                  }`}
                >
                  <div className='max-w-[70%]'>
                    <div className='text-xs text-gray-500 mb-1'>
                      {msg.sender_name}
                    </div>
                    <div
                      className={`rounded-lg px-3 py-2 text-sm ${
                        msg.sender_name !== 'HR'
                          ? 'bg-hr-primary-1 text-white'
                          : 'bg-gray-200'
                      }`}
                    >
                      {msg.comment}
                    </div>
                  </div>
                </div>
              ))
            )}
          </main>
        </div>

        <div className='flex gap-3 items-center'>
          <input
            type='text'
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            placeholder='Send a reply'
            className='w-[75%] h-[52px] px-3 border border-[#96969B] rounded-lg text-sm placeholder:text-sm outline-none text-inherit'
          />
          <div className='w-[25%]'>
            <Button
              text={'Send'}
              type='button'
              disabled={addQueryMessageloading}
              onClick={() => {
                submitForm()
              }}
              textClass={'!text-[16px]'}
              className={'h-[52px] w-full font-medium'}
              loading={addQueryMessageloading}
            />
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default QueryModal
